<template>
  <!-- App.vue -->

  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <div
        style="text-align: center; padding-left: 30% !important"
        width="100%; z-index:19"
      >
        <v-alert
          v-if="responseStatus.alertStatus"
          :type="responseStatus.type"
          width="40%"
          style="z-index: 9999; text-align: left"
          dense
          dismissible
          @input="responseStatus.alertStatus = !responseStatus.alertStatus"
        >
          {{ responseStatus.text }}
        </v-alert>
      </div>
      <!-- add/edit product -->
      <v-navigation-drawer v-model="dialog" temporary right app width="480px">
        <v-card>
          <v-card-title>
            <v-icon @click="close">mdi-close-circle</v-icon>
            <span class="headline"> {{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <!-- <v-text-field
                      v-model="editProductList.sku"
                      label="รหัสสินค้า"
                      aria-required="required"
                    ></v-text-field> -->
                  <v-combobox
                    v-model="product"
                    :items="Products"
                    item-text="name"
                    item-value="sku"
                    label="ชื่อสินคัา"
                    placeholder="กรอกอย่างน้อย 3 ตัวอักษร"
                    prepend-icon="mdi-database-search"
                    return-object
                    @change="setProductData"
                  ></v-combobox>
                </v-col>

                <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="editProductList.name"
                      label="ชื่อ"
                      aria-required="required"
                      readonly
                    ></v-text-field>
                  </v-col> -->

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editProductList.price"
                    label="ราคา (บาท)"
                    aria-required="required"
                    min="0"
                    type="text"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editProductList.quantity"
                    label="จำนวน"
                    aria-required="required"
                    type="number"
                    min="1"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="editProductList.discount"
                    label="ส่วนลด (บาท)"
                    aria-required="required"
                    type="number"
                    min="0"
                    @change="blurDiscount"
                  ></v-text-field>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="amount"
                      label="สุทธิ (บาท)"
                      aria-required="required"
                      type="text"
                    ></v-text-field>
                  </v-col>
                </v-col>
              </v-row>
              <!-- <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="categoryList"
                      label="Category"
                      v-model="editProductList.category"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="subCategoryList"
                      label="Sub-Category"
                      v-model="editProductList.subCategory"
                      required
                    ></v-select>
                  </v-col>
                </v-row> -->
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" @click="close"> ยกเลิก</v-btn>
            <v-btn tile color="success" @click="addProduct"> ยืนยัน</v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

      <!-- end add/edit product -->
      <!-- redeem point layout -->

      <!-- end redeem point layout-->

      <!-- delete product dialog -->
      <v-dialog v-model="dialogDelete" max-width="30%">
        <v-card>
          <v-card-title class="headline"
            >ต้องการลบสินค้า {{ editProductList.name }} ?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info darken-1" @click="closeDelete">ยกเลิก</v-btn>
            <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end delete product -->
      <!-- delete redeem point dialog -->
      <v-dialog v-model="dialogDeleteOrder" max-width="600px">
        <v-card>
          <v-card-title class="headline">ต้องการลบรายการขาย ?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="dialogDeleteOrder = !dialogDeleteOrder"
              >Cancel</v-btn
            >
            <v-btn color="success" @click="deleteOrderConfirm">ยืนยัน</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end delete redeem point  -->

      <v-card>
        <v-card-title>
          รายการสินค้า
          <v-spacer></v-spacer>
          <!-- <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field> -->
        </v-card-title>
        <v-toolbar flat>
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            dark
            class="mb-2"
            @click="editItem(item)"
            v-if="saleInfo.status != 'Completed'"
          >
            <v-icon left>mdi-plus</v-icon> เพิ่มสินค้า
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"
            :headers="headers"
            :items="saleProduct"
            :footer-props="{ 'items-per-page-options': [15, 30, 50, 100] }"
          >
            <template v-slot:item.image="{ item }">
              <v-img
                :src="api_uri + '/public/' + item.image"
                style="height: auto; max-width: 120px"
              ></v-img>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data> </template>
          </v-data-table>
        </v-card-text>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="12" md="6" offset-md="6" offset-sm="0">
                <v-text-field
                  v-model="sale_amount"
                  label="รวม (บาท)"
                  aria-required="required"
                  min="0"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="12" md="6" offset-md="6" offset-sm="0">
                <v-text-field
                  v-model="discount"
                  :label="'ส่วนลดเทียร์ (' + tierDiscount + ' %)'"
                  aria-required="required"
                  min="0"
                  type="number"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="12" md="6" offset-md="6" offset-sm="0">
                <v-text-field
                  v-model="saleInfo.point_cash"
                  :label="
                    'คะแนนแทนเงินสด (คะแนน) 1 : ' + saleInfo.point_cash_rate + ' บาท'
                  "
                  aria-required="required"
                  min="0"
                  type="number"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="12" md="6" offset-md="6" offset-sm="0">
                <v-text-field
                  v-model="sale_discount"
                  label="ส่วนลดรวม (บาท)"
                  aria-required="required"
                  min="0"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="12" md="6" offset-md="6" offset-sm="0">
                <v-text-field
                  v-model="sale_total"
                  label="สุทธิ (บาท)"
                  aria-required="required"
                  min="0"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="justify-center"
          ><v-btn color="info darken-1" @click="closeProduct">Close</v-btn>
          <v-btn
            color="primary darken-1"
            @click="saveSaleProduct"
            v-if="saleInfo.status != 'Completed'"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import _ from "underscore";
import moment from "moment";
import { summary } from "../../../library/functions.js";
//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";
//import { VueEditor } from "vue2-editor";

export default {
  name: "OrderList",
  props: {
    saleInfo: {
      type: Object,
    },
    member: {
      type: Object,
    },
  },
  components: {
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
    //   VueEditor,
  },
  data() {
    return {
      // datepicker
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      nowDate: moment(moment()).add(0, "days").toISOString().slice(0, 10),
      minExpire: moment(moment()).add(2, "days").toISOString().slice(0, 10),
      start: "",
      expire: "",
      //
      image: "",
      drawer: null,
      drawerOrder: null,
      closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      dialogDeleteOrder: false,
      editProductList: {
        discount: 0,
        quantity: 1,
        price: 1,
        amount: 0,
      },
      orderHistory: {},
      point: "",
      cash: "",
      responseStatus: {
        alertStatus: false,
      },
      show: false,
      defaultItem: {},
      deleteIndex: -1,
      editedIndex: -1,
      edit: false,
      term: null,
      search: "",
      payload: {},
      product: "",
      // member: {
      //   _id: "",
      // },
      //saleProduct: [],

      totalItems: 0,
      //tierDiscount: 0,
      options: { sortBy: "createdAt", sortDesc: true },
      Products: [],

      headers: [
        // {
        //   value: "sku",
        //   text: "รหัสสินค้า",
        // },
        {
          value: "image",
          text: "รูปสินค้า",
        },
        {
          value: "name",
          text: "สินค้า",
        },
        {
          value: "quantity",
          text: "จำนวน", // this.$t("tables.headings.status")
        },
        /*
        {
          value: "order_history",
          text: "รายการขาย", // this.$t("tables.headings.order_history")
        },*/
        {
          value: "price",
          text: "ราคา (บาท)", // this.$t("tables.headings.quantity")
        },
        // {
        //   value: "discount",
        //   text: "ส่วนลด (บาท)", // this.$t("tables.headings.quantity")
        // },
        {
          value: "amount",
          text: "สุทธิ (บาท)", // this.$t("tables.headings.quantity")
        },

        {
          value: "actions",
          text: "Actions", // this.$t("tables.headings.actions")
        },
      ],
      //sale_total: 0,
      //: 0,
    };
  },
  created() {
    //this.nowDate.setDate(this.nowDate.getDate() + 7);
    //this.nowDate.toISOString().slice(0,10);
    //console.log(this.nowDate);
  },
  computed: {
    tierDiscount() {
      // console.log("tierDiscount");
      // console.log(this.member);
      if (
        this.saleInfo.tierInformation !== undefined &&
        this.saleInfo.tierInformation != null
      ) {
        //
        return this.saleInfo.tierInformation.defaultDiscount;
      } else if (this.member.tierId !== undefined && this.member.tierId != null) {
        return this.member.tierId.defaultDiscount;
      } else {
        return 0;
      }
    },
    discount() {
      return (this.tierDiscount / 100) * this.sale_amount;
    },
    sale_amount() {
      // console.log(this.saleProduct);
      // let n = 0;
      let result = this.saleProduct.reduce(function (curVal, obj) {
        // console.log(curVal);
        // console.log(obj.amount);
        // console.log("xxx");
        return parseFloat(obj.amount) + curVal;
      }, 0);
      // console.log(n);
      // console.log(result);
      return result;
    },
    sale_total() {
      return this.sale_amount - this.sale_discount < 0
        ? 0
        : this.sale_amount - this.sale_discount;
    },
    sale_discount() {
      return (
        (this.tierDiscount / 100) * this.sale_amount +
          parseFloat(this.saleInfo.point_cash) *
            parseFloat(this.saleInfo.point_cash_rate) || 0
      );
    },
    now() {
      return new Date().getTime();
    },
    totalSaleProduct() {
      //
      return this.$store.state.totalItems || 0;
    },
    saleProduct() {
      console.log(this.member);
      return (
        this.$store.state.saleProduct ||
        this.saleInfo.products || [{ _id: null, name: "", price: 0 }]
      );
    },
    // ProductFilter() {
    //   if (this.search.length > 0) {
    //     return this.Products.filter(() => {
    //       //return item.name.toLowerCase().startsWith(this.search.toLowerCase());
    //       this.readProducts().then((response) => {
    //         this.Products = response.data.filter((item) => {
    //           item.image = this.api_uri + "/public/" + item.image;
    //           console.log(item);
    //           return item;
    //         });
    //         this.totalItems = response.totalItems;
    //       });
    //     });
    //   } else {
    //     return this.Products;
    //   }
    // },
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่มรายการสินค้า" : "แก้ไขรายการสินค้า";
    },
    categoryList() {
      return this.$store.getters.getCategory.map((item) => {
        return { text: item.name, value: item.name };
      });
    },
    subCategoryList() {
      //console.log("subCategoryList");
      return this.$store.getters.getSubCategory
        .filter((item) => {
          return item.category == this.editProductList.category;
        })
        .map((item) => {
          return { text: item.name, value: item.name };
        });
    },

    amount() {
      //console.log(this.editProductList);
      return (
        this.editProductList.price * this.editProductList.quantity -
        this.editProductList.discount
      );
    },
  },
  mounted() {
    // if (!this.show) {
    //   console.log("mounted sale product");

    //   //this.memberInfo();
    //   this.show = true;
    //   console.log(this.member);
    // }
    //console.log(this.saleProduct());
    console.log(this.saleInfo);
    // console.log("product mounted");
    // this.$store.dispatch("setCategoryList");
    // this.$store.dispatch("setSubCategoryList");
    this.$store.dispatch("setSaleProduct", this.saleInfo.products || []);

    this.readProducts().then((response) => {
      //console.log(response);
      this.Products = response.data.filter((item) => {
        //item.image = this.api_uri + "/public/" + item.image;
        delete item.image;
        //console.log(item);
        return item;
      });
      //this.totalItems = response.totalItems;
    });
  },
  methods: {
    blurDiscount() {
      // console.log(this.editProductList.discount);
      if (parseFloat(this.editProductList.discount) < 0) {
        this.editProductList.discount = 0;
      }
      this.editProductList.price * this.editProductList.quantity -
        this.editProductList.discount;
    },
    async saveSaleProduct() {
      //update sale db / hubspot
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      //this.api_uri + console.log(url);
      this.show = false;
      let payload = {
        sales: this.$store.state.sales,
        tierDiscount: this.tierDiscount,
        discount: this.discount,
        sale_total: this.sale_total,
        sale_amount: this.sale_amount,
        sale_discount: this.sale_discount,
        sumDiscount: this.sale_discount,
        amount: this.sale_total,
        total: this.sale_amount,
        apiKey: sessionStorage.getItem("apiKey"),
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        "token": sessionStorage.getItem("token"),
      };
      await axios
        .put(this.api_uri + "/v1/sales/update-sale-product", payload, {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json",
            "token": sessionStorage.getItem("token"),
          },
        })
        .then((response) => {
          //
          //console.log("update - sale - product");
          //console.log(response);
          if (response.data.code == 0) {
            this.$store.dispatch("updateSalesStatus", "Completed");
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
            };
            //console.log(this.responseStatus);
          }
        })

        .catch((err) => {
          this.responseStatus = {
            status: "Error",
            code: 500,
            message: err,
          };
        });
    },
    closeProduct() {
      this.show = false;
      this.$emit("closeProduct");
    },
    async addProduct() {
      // console.log("addProduct");
      this.close();
      //console.log(this.editProductList);
      if (this.editedIndex > -1) {
        //
        Object.assign(this.editProductList, { amount: this.amount });
        await this.$store.dispatch("updateSaleProduct", {
          payload: this.editProductList,
          index: this.editedIndex,
        });
        //this.saleProduct.product[this.editedIndex] = this.editProductList;
        this.saleInfo.products = this.$store.state.saleProduct;
        this.$store.dispatch("setSales", this.saleInfo);
        //console.log(this.$store.state.saleProduct);
        //this.saleProduct = this.$store.state.saleProduct;
        this.editProductList = {};
        //console.log(this.saleProduct);
      } else {
        Object.assign(this.editProductList, { amount: this.amount });
        await this.$store.dispatch("addSaleProduct", this.editProductList);
        //this.saleInfo.product.push(this.editProductList);
        this.saleInfo.products = this.$store.state.saleProduct;
        this.$store.dispatch("setSales", this.saleInfo);

        //console.log(this.$store.state.saleProduct);
        //this.saleProduct = this.$store.state.saleProduct;
        this.editProductList = {};
        //console.log(this.saleProduct);
      }
      //this.$store.state.sales[this.editedIndex].amount = this.$store.state.sales[this.editedIndex].amount+this.editProductList.amount;
      // console.log(summary(this.saleInfo.products, "amount"));
      // console.log(this.$store.state.salesList.indexOf(this.saleInfo));
      // console.log(
      //   this.$store.state.salesList[this.$store.state.salesList.indexOf(this.saleInfo)]
      // );
      this.$store.state.salesList[
        this.$store.state.salesList.indexOf(this.saleInfo)
      ].amount = summary(this.saleInfo.products, "amount");
      // console.log(
      //   this.$store.state.salesList[this.$store.state.salesList.indexOf(this.saleInfo)]
      // );
    },
    setProductData() {
      // console.log(this.editProductList);
      this.editProductList = this.product;
      if (this.editProductList.discount === undefined) {
        this.editProductList = {
          ...this.editProductList,
          discount: 0,
          quantity: 1,
          price: this.product.price,
          amount: 0,
        };
      }
    },

    readProducts() {
      ////const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          custId: sessionStorage.getItem("custId"),
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        return axios
          .get(
            this.api_uri + "/v1/products/list",
            { params: this.payload }, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
                "token": sessionStorage.getItem("token"),
              },
            }
          )
          .then((response) => {
            return response.data;
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },
    resetInput() {
      console.log("input reset");
      //this.editedIndex = null;
      //this.editProductList = null;
      this.image = "";
    },
    // redeem
    vieworderHistory(item) {
      this.orderHistory = item;
      this.editedIndex = item._id;
    },
    async addOrder() {
      if (this.editedIndex > -1) {
        //console.log("update");
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payload = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),

            //...this.editProductList,
            //image: this.image,
            id: this.orderHistory._id,
          };
          //console.log(this.payload);
          await axios
            .put(
              this.api_uri + "/v1/products/updateorderHistory",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              //console.log(response.data)
              //this.Product = response.data;
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              //console.log(this.responseStatus)
              //this.Product = response.data;
              this.resetInput();
            });

          //console.log(this.Product);
          //console.log("updated");
          // if (this.Product.nModified == 1) {
          //   Object.assign(this.Products[this.editedIndex], this.editProductList);
          // } else {
          //   // do something
          // }
        } catch (err) {
          //console.log(err)
          //return err;
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      } else {
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payload = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),

            id: this.orderHistory._id,
            order_history: [
              ...this.orderHistory.order_history,
              {
                //
              },
            ],
          };
          await axios
            .post(
              this.api_uri + "/v1/products/updateorderHistory",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              //this.totalItems++;
              // Object.assign(this.orderHistory.order_history , {
              //   point: this.point,
              //   cash: this.cash,
              // });
              this.orderHistory.order_history = [
                ...this.orderHistory.order_history,
                {
                  //
                },
              ];
              //console.log(this.orderHistory.order_history);
              this.resetInput();
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      }
      // if(this.responseStatus.code == 0){
      //   this.totalItems++;
      // }
      //console.log("saved");
      console.log(this.orderHistory.order_history);
      //this.close();
    },
    deleteOrder(item) {
      console.log("deleteOrder");
      console.log(item);
      this.deleteIndex = this.orderHistory.order_history.indexOf(item);
      //this.$store.dispatch("removeSaleProduct", item);

      this.dialogDeleteOrder = true;
    },
    async deleteOrderConfirm() {
      console.log("deleteOrderConfirm");
      this.dialogDeleteOrder = !this.dialogDeleteOrder;

      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payload = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          point: this.orderHistory.order_history[this.deleteIndex].point,
          cash: this.orderHistory.order_history[this.deleteIndex].cash,
        };

        const response = await axios.post(
          this.api_uri + "/v1/products/deleteOrderHistory/" + this.orderHistory._id,
          this.payload
        );
        //console.log(response);

        if (response.data.n == response.data.nModified > 0) {
          this.responseStatus = {
            status: "Success",
            code: 0,
            color: "green",
            type: "success",
            text: "บันทึกสำเร็จ",
            alertStatus: true,
          };
          //this.orderHistory.order_history.splice(this.deleteIndex, 1);
          this.$store.dispatch("removeSaleProduct", this.deleteIndex);
          this.resetInput();
        } else {
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: "ล้มเหลว",
            alertStatus: true,
          };
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }

      //this.closeDeleteR();
    },
    // end redeem
    editItem(item) {
      this.editedIndex = this.$store.state.saleProduct.indexOf(item);
      this.editProductList = Object.assign({}, item);
      this.product = this.editProductList.name;
      //console.log("editProductList");
      //console.log(this.editProductList);

      // if (_.size(this.editProductList) > 0) {
      //   if (this.editProductList.image != "") {
      //     this.image = this.editProductList.image;
      //   } else {
      //     this.image = "";
      //   }
      // }

      this.edit = this.editedIndex !== -1 ? true : false;
      /*if(!this.edit){
        this.editProductList =  {
        discount: 0,
        quantity: 1,
        price: 1,
        amount: 0,
      }

      }*/
      this.editProductList.discount =
        this.editProductList.discount == undefined || this.editProductList.discount == ""
          ? 0
          : this.editProductList.discount;
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.$store.state.saleProduct.indexOf(item);
      this.editProductList = {};
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      /*
      console.log("deleteConfirm");
      //const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        const response = await axios.delete(
          this.api_uri + "/v1/products/delete/" + this.editProductList._id
        );
        //console.log(response);

        if (response.data.n == response.data.deletedCount > 0) {
          this.responseStatus = {
            status: "Success",
            code: 0,
            color: "green",
            type: "success",
            text: "บันทึกสำเร็จ",
            alertStatus: true,
          };
          this.Products.splice(this.editedIndex, 1);
          //this.readProducts()
          this.totalItems--;
        } else {
          this.responseStatus = {
            status: "Error",
            code: 8001,
            color: "red",
            type: "error",
            text: "ล้มเหลว",
            alertStatus: true,
          };
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }
      */
      console.log("CALL removeSaleProduct ");
      this.$store.dispatch("removeSaleProduct", this.editedIndex);
      this.saleInfo.products = this.$store.state.saleProduct;

      this.$store.dispatch("setSales", this.saleInfo);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.edit = false;
      console.log("close");
      this.$nextTick(() => {
        console.log("nexttick");
        this.editProductList = {};
        this.product = "";
        //this.image = "";
        //if (this.editProductList.image == "" || this.editProductList.image.length == 0 ) this.image = "";
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editProductList = {};
        //this.image = null;
        this.product = "";
        this.editedIndex = -1;
      });
    },
    // timeout close overlay
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    async save() {
      if (this.editedIndex > -1) {
        console.log("update");
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payload = {
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),

            ...this.editProductList,
            id: this.editProductList._id,
          };
          console.log(this.payload);
          await axios
            .put(
              this.api_uri + "/v1/products/update",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              //console.log(response.data)
              //this.Product = response.data;

              //console.log(this.responseStatus)
              //this.Product = response.data;
              //console.log(response.data);
              if (response.data.nModified == 1) {
                this.responseStatus = {
                  status: "Success",
                  code: 0,
                  color: "green",
                  type: "success",
                  text: "บันทึกสำเร็จ",
                  alertStatus: true,
                  data: response.data,
                };

                // Object.assign(this.Products[this.editedIndex], response.data.data);
                // console.log(this.Products[this.editedIndex]);
              } else {
                // do something
              }
            });

          //console.log(this.Product);
          //console.log("updated");
        } catch (err) {
          //console.log(err)
          //return err;
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      } else {
        //const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payload = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),
            apiKey: sessionStorage.getItem("apiKey"),

            ...this.editProductList,
          };
          await axios
            .post(
              this.api_uri + "/v1/products/create",
              this.payload, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                  "token": sessionStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              this.totalItems++;
            })
            .catch((error) => {
              this.responseStatus = {
                status: "Error",
                code: 500,
                color: "red",
                type: "error",
                text: error,
                alertStatus: true,
              };
            });
        } catch (err) {
          this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          };
        }
      }
      // if(this.responseStatus.code == 0){
      //   this.totalItems++;
      // }
      console.log("saved");
      //this.$store.dispatch("setSales", this.saleInfo);
      console.log(this.totalItems);
      this.$store.state.saleProduct[this.editedIndex] = this.editedItem;
      //this.close();
    },

    handleImage(e) {
      //console.log(e);
      console.log(typeof e);
      //console.log(e.target.file[0])
      //const uploadImage = e.target.files[0];
      //console.log(this.editProductList.image);
      if (typeof e != "undefined") {
        this.createBase64Image();
      } else {
        this.image = "";
      }
    },
    createBase64Image() {
      const limitSize = 1000000;
      const reader = new FileReader();
      reader.readAsDataURL(this.editProductList.image);
      reader.onload = (e) => {
        console.log(e);
        if (e.total > limitSize) {
          this.imageError = "Size more than 1MB!";
          this.image = "";
        } else {
          this.image = e.target.result;
          this.imageError = "";
        }
        //console.log(e.target.result);
      };
      //console.log(reader.readAsDataURL(this.image));
    },
  },

  watch: {
    options: {
      handler() {
        console.log(this.options);
        this.payload = {
          custId: sessionStorage.getItem("custId"),

          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
        };

        // this.readProducts().then((response) => {
        //   this.Products = response.data.filter((item) => {
        //     item.image = this.api_uri + "/public/" + item.image;
        //     console.log(item);
        //     return item;
        //   });
        //   this.totalItems = response.totalItems;
        // });
      },
      deep: true,
    },

    search: {
      handler() {
        console.log("search");
        // this.readProducts().then((response) => {
        //   this.Products = response.data;
        //   this.totalItems = response.totalItems;
        // });
      },
    },
    dialog(val) {
      console.log(val);
      // if (this.editedIndex == -1 && this.editProductList.image == "") {
      //   this.image = "";
      // }
      val || this.close();
    },
    dialogDelete(val) {
      console.log(val);
      val || this.closeDelete();
    },
    totalItems: {
      handler() {
        //console.log(this.totalItems)
        // this.readProducts().then((response) => {
        //   this.Products = response.data.filter((item) => {
        //     item.image = this.api_uri + "/public/" + item.image;
        //     console.log(item);
        //     return item;
        //   });
        //   this.totalItems = response.totalItems;
        // });
      },
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
    editProductList: {
      handler() {
        //console.log("editProductList");
        console.log(this.editProductList);
        //console.log(_.size(this.editProductList));
        if (_.size(this.editProductList) > 0) {
          /*
           if (this.editProductList.image != "") {
             this.image = this.editProductList.image
           } else {
             this.image = "";
           }
           */
          if (this.editProductList.quantity <= 0) {
            this.editProductList.quantity = 1;
          }
          if (
            this.editProductList.discount == "" ||
            this.editProductList.discount === undefined
          ) {
            this.editProductList.discount = 0;
          }
        }
      },
    },
  },
};
</script>
